import "./service-bar.less";
export default function ServiceBar() {
    return {
        restrict: "E",
        scope: {
            searchResults: "=", // object
            pageTitle: "=",
            showComponents: "=", // array of string (names of service-bar components to show )
        },
        template: require("./service-bar.html"),

        controller: function (
            $scope,
            $rootScope,
            $location,
            siteService,
            houseService,
            Basket,
            navService,
            $timeout
        ) {
            $scope.siteService = siteService;

            var setPageTitleRootEventListener = $rootScope.$on(
                "set-page-title-root",
                function (event, pageTitle) {
                    $scope.theTitle = pageTitle.title;
                }
            );
            $scope.$on("$destroy", setPageTitleRootEventListener);

            var setPageTitleEventListener = $scope.$on(
                "set-page-title",
                function (event, pageTitle) {
                    //console.log(pageTitle.title + ' scope' )

                    $timeout(function () {
                        $scope.$apply(function () {
                            $scope.theTitle = pageTitle.title;
                        });
                    });
                }
            );
            $scope.$on("$destroy", setPageTitleEventListener);

            var selectHouseEventListener = $scope.$on(
                "selected-house-broadcast",
                function (event, selectedHouse) {
                    $scope.selectedHouse = houseService.selectedHouse =
                        selectedHouse;
                }
            );
            $scope.$on("$destroy", selectHouseEventListener);

            var selectedActivityEventListener = $scope.$on(
                "selected-activity-broadcast",
                function (event, selectedActivity) {
                    $scope.selectedActivity = houseService.selectedActivity =
                        selectedActivity;
                }
            );
            $scope.$on("$destroy", selectedActivityEventListener);

            var nextResultsEventListener = $scope.$on(
                "next-results-update-broadcast",
                function (event, nextSearchResults) {
                    $scope.nextSearchResults = nextSearchResults;

                    //console.log( $filter("date")( nextSearchResults.NextAvailableDate, 'dd-MM-yyyy') );
                }
            );
            $scope.$on("$destroy", nextResultsEventListener);

            $scope.selectedBookings = Basket.currentBookings;

            $scope.searchFilter = houseService.searchFilter;

            // overviewFilter
            // which return example.. all activities (date independant)
            // searchType : 1 = activities , 2 = places
            // categoryID : find all (searchType) with a specific category
            $scope.listAll = function (
                $event,
                searchType,
                houseCategoryID,
                houseTypeID,
                path
            ) {
                houseService.overviewFilter.overviewNow(
                    searchType,
                    houseCategoryID,
                    houseTypeID,
                    path
                );

                if ($location.url().split("/")[1] != "overview") {
                    // change Url to overview with route Params
                    var reload = true;
                    $location.path(path, reload);
                }
            };
        },
    };
}
